require('paroller.js')

const init = () => {
  $("[data-paroller-factor]").paroller()
}

export default init
